/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Status information about the pricing calculation for this cart or order.
 * @export
 * @interface SAPCalculationStatus
 */
export interface SAPCalculationStatus {
    /**
     * Indicates whether the system fell back to internal pricing due to an external engine failure. When true, externalFailureCode and externalFailureMessage provide additional details.
     * @type {boolean}
     * @memberof SAPCalculationStatus
     */
    fallback?: boolean;
    /**
     * Timestamp when the external calculation was performed.
     * @type {Date}
     * @memberof SAPCalculationStatus
     */
    calculatedAt?: Date;
    /**
     * Digest or hash identifying the specific calculation result from the external engine. Can be used for cache validation or audit.
     * @type {string}
     * @memberof SAPCalculationStatus
     */
    calculationDigest?: string;
    /**
     * Timestamp until which the externally calculated prices are valid. After this time the cart should be recalculated before placing an order.
     * @type {Date}
     * @memberof SAPCalculationStatus
     */
    validUntil?: Date;
    /**
     * Error code from the external engine. Present only when fallback is true.
     * @type {string}
     * @memberof SAPCalculationStatus
     */
    externalFailureCode?: string;
    /**
     * Human-readable error message from the external engine. Present only when fallback is true.
     * @type {string}
     * @memberof SAPCalculationStatus
     */
    externalFailureMessage?: string;
}

/**
 * Check if a given object implements the SAPCalculationStatus interface.
 */
export function instanceOfSAPCalculationStatus(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SAPCalculationStatusFromJSON(json: any): SAPCalculationStatus {
    return SAPCalculationStatusFromJSONTyped(json, false);
}

export function SAPCalculationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAPCalculationStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fallback': !exists(json, 'fallback') ? undefined : json['fallback'],
        'calculatedAt': !exists(json, 'calculatedAt') ? undefined : (new Date(json['calculatedAt'])),
        'calculationDigest': !exists(json, 'calculationDigest') ? undefined : json['calculationDigest'],
        'validUntil': !exists(json, 'validUntil') ? undefined : (new Date(json['validUntil'])),
        'externalFailureCode': !exists(json, 'externalFailureCode') ? undefined : json['externalFailureCode'],
        'externalFailureMessage': !exists(json, 'externalFailureMessage') ? undefined : json['externalFailureMessage'],
    };
}

export function SAPCalculationStatusToJSON(value?: SAPCalculationStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fallback': value.fallback,
        'calculatedAt': value.calculatedAt === undefined ? undefined : (value.calculatedAt.toISOString()),
        'calculationDigest': value.calculationDigest,
        'validUntil': value.validUntil === undefined ? undefined : (value.validUntil.toISOString()),
        'externalFailureCode': value.externalFailureCode,
        'externalFailureMessage': value.externalFailureMessage,
    };
}

